import { connect } from 'react-redux';
import React, {Component} from 'react';
import {Segment, Header, Button} from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import _ from 'underscore';
import {
    getMHCRewardsDetail,
} from '../../actions';
import RewardRedeemHTMLTemplate from '../../template/rewardRedeemHTMLTemplate';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import moment from 'moment';
const GLOBAL_DATETIME = 'DD MMM YYYY h:mm A'
const NOTIFICATION_DATE_FORMAT = 'DD/MM/YYYY hh:mm A';

const REWARDS_EXPIRED_DATE_FORMAT = 'DD/MM/YYYY hh:mm A';



class RewardsDetailsRedeemedPage extends Component {

    componentDidMount() {
        const {accessToken} = this.props.user;
        console.log('this.props.match.params', this.props.match.params);
        const rewardID = this.props.match.params.rewardId;
        this.props.getMHCRewardsDetail(accessToken, rewardID);
    }

    render() {
      const linkPhone = "tel:";
      const linkEmail = "mailto:";

      const className = 'Reward'
      let htmlString = ''
      var reward = this.props.reward

      console.log('reward-', reward);

      if (reward) {
            var fullImageURL = ''
            var findIndex = reward.thumbnailURL.indexOf(".100x100")
            if (findIndex != -1) {
                fullImageURL = reward.thumbnailURL.substring(0, findIndex);
            }

            let contactNo = null
            if (reward.contact_details && reward.contact_details.phone) {
                var regex = /[0-9+]/g;
                var filteredPhoneNo = reward.contact_details.phone.match(regex);
                if (filteredPhoneNo)
                    contactNo = filteredPhoneNo.join('')
            }

            htmlString = RewardRedeemHTMLTemplate.replace(/\n/g, "")
                .replace(/%%Header-Image%%/g, fullImageURL)
                .replace(/%%Header-Title%%/g, reward.title ? reward.title : '-')
                .replace(/%%Header-Description%%/g, reward.excerpt ? reward.excerpt : '-')
                .replace(/%%Call-Phone%%/g, contactNo ? linkPhone + contactNo : '-')
                .replace(/%%Content-Phone%%/g, contactNo ? contactNo : '-')
                .replace(/%%Mail-To%%/g, reward.contact_details && reward.contact_details.email ? linkEmail + reward.contact_details.email : '-')
                .replace(/%%Content-Email%%/g, reward.contact_details && reward.contact_details.email ? reward.contact_details.email : '-')
                .replace(/%%Content-Website%%/g, reward.merchant && reward.merchant.website ? reward.merchant.website : '-')
                .replace(/%%Content-About%%/g, reward.merchant && reward.merchant.description ? reward.merchant.description : '-')
                .replace(/%%Content-Terms%%/g, reward.terms_and_conditions ? reward.terms_and_conditions.replace(/&nbsp;/g, "") : '-')
                .replace(/%%Content-Valid-Date%%/g, reward.endDate ? moment(reward.endDate).format(REWARDS_EXPIRED_DATE_FORMAT) : '-')
                .replace("%%Content-Address%%", reward.locations && reward.locations.length > 0 && reward.locations[0] && reward.locations[0].address ? reward.locations[0].address : "N/A")
                .replace("%%Coordinates-Lat%%", reward.locations && reward.locations.length > 0 && reward.locations[0] && reward.locations[0].coordinates && reward.locations[0].coordinates[1] ? reward.locations[0].coordinates[1] : "0.0")
                .replace("%%Coordinates-Long%%", reward.locations && reward.locations.length > 0 && reward.locations[0] && reward.locations[0].coordinates && reward.locations[0].coordinates[0] ? reward.locations[0].coordinates[0] : "0.0")
                .replace(/%%Show-Map-Start%%/g, reward.locations && reward.locations.length > 0 && reward.locations[0] && reward.locations[0].coordinates && reward.locations[0].coordinates[1] ? "" : "<!--")
                .replace(/%%Show-Map-End%%/g, reward.locations && reward.locations.length > 0 && reward.locations[0] && reward.locations[0].coordinates && reward.locations[0].coordinates[1] ? "" : "-->")
                .replace("%%Redeem-Description%%", reward.redeemedDetails && reward.redeemedDetails.description ? reward.redeemedDetails.description : '-')
                .replace("%%Redeem-Reference%%", reward.redeemedDetails && reward.redeemedDetails.reference ? reward.redeemedDetails.reference.toString() : '-')
                .replace("%%Redeemed-Date%%", reward.redeemedDetails && reward.redeemedDetails.created ? moment(reward.created).format(GLOBAL_DATETIME) : '-')
                .replace(/%%Content-Attachment%%/g, reward.brochure ? reward.brochure : 'N/A')
                .replace(/%%Show-Attachment-Start%%/g, reward.brochure ? "" : "<!--")
                .replace(/%%Show-Attachment-End%%/g, reward.brochure ? "" : "-->")

        }
        return (
            <div>
              { ReactHtmlParser(htmlString) }
            </div>

        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user.user,
        reward: state.appConfig.reward,
    }
}

export default connect(mapStateToProps, {
    getMHCRewardsDetail,
})(RewardsDetailsRedeemedPage);
